"use strict";

$(document).ready(function () {
  // if($('.-current.js-current-step').find('.content-block.collapse.show').length === 1){
  //     var styles = {
  //         height : "auto",
  //         display: "block"
  //     };
  //     $('.-current.js-current-step').find('.content-block.collapse.show').css(styles);
  // }
  if ($('body#checkout #js-checkout-summary').length > 0) {// accordion();
  }

  if ($('body#checkout #delivery-address').length > 0) {
    $('.form-group .custom-select').select2({
      minimumResultsForSearch: -1
    });
  }

  if ($('#checkout #login-form input[type=email]').length > 0) {
    $('#checkout #login-form input[type=email]').blur(function () {
      if ($(this).val() !== '') {
        $('#checkout #login-form input[type=password]').focus();
      }
    });
  }

  if ($('#id-address-delivery-address-select').length > 0) {
    $(document).on('change', '#id-address-delivery-address-select', function () {
      var thisVal = $(this).val();
      setTimeout(function () {
        $('#delivery-addresses .address-item-block').each(function (i) {
          if ($(this).attr('data-id') !== thisVal) {
            $(this).css('display', 'none');
          } else {
            $(this).removeAttr('style');
          }
        });
      }, 50);
    });
  }

  if ($('#id-address-invoice-address-select').length > 0) {
    $(document).on('change', '#id-address-invoice-address-select', function () {
      var thisVal = $(this).val();
      setTimeout(function () {
        $('#invoice-addresses .address-item-block').each(function (i) {
          if ($(this).attr('data-id') !== thisVal) {
            $(this).css('display', 'none');
          } else {
            $(this).removeAttr('style');
          }
        });
      }, 50);
    });
  }

  $('.address-select').on('change', function () {
    var $this = $(this);
    $this.parent('.address-selector').children('article').css('display', 'none');
    var addressType = $this.data('address-type');
    var id = $this.val();
    $('#' + addressType + '-address-' + id).css('display', '');
  });

  if ($('.mobileChoice--item').length > 0) {
    $('.mobileChoice--item').click(function () {
      var thisEl = $(this);
      var thisId = thisEl.attr('id');
      var formBlock = $('.' + thisId);

      if (!thisEl.hasClass('active')) {
        $('.mobileChoice--item').not(thisEl).removeClass('active');
        thisEl.addClass('active');
        $('.choise-form').not(formBlock).removeClass('active');
        $(formBlock).addClass('active');
      }
    });
  }

  if ($('.payment-method-input').length > 0) {
    $(document).on('change', '.payment-method-input', function () {
      var thisEl = $(this);
      var thisId = thisEl.attr('id');
      $('.payment-options-description #' + thisId + '-additional-information').slideDown(300);
    });
  } // Adds error icon to cart error notice


  prestashop.on('updatedCart', function () {
    if ($('body#cart').length > 0) {
      var errorIcon = '<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M22.6764 17.1796L14.6885 2.4743C14.0859 1.45966 13.021 0.853516 11.8404 0.853516C10.6599 0.853516 9.59543 1.45966 8.99238 2.4743C8.98796 2.48224 8.98399 2.49018 8.97958 2.49768L1.01815 17.1566C0.402306 18.1929 0.390837 19.4374 0.986389 20.4851C1.58371 21.5337 2.65923 22.1593 3.86577 22.1593H19.771C20.9775 22.1593 22.0976 21.5337 22.6945 20.4851C23.29 19.4374 23.2786 18.1929 22.6764 17.1796ZM10.5157 7.58679C10.5157 6.85492 11.109 6.26201 11.8404 6.26201C12.5723 6.26201 13.1652 6.85492 13.1652 7.58679V12.8859C13.1652 13.6173 12.5723 14.2106 11.8404 14.2106C11.109 14.2106 10.5157 13.6173 10.5157 12.8859V7.58679ZM11.8404 19.5097C10.7446 19.5097 9.85306 18.6182 9.85306 17.5228C9.85306 16.427 10.7446 15.5354 11.8404 15.5354C12.9363 15.5354 13.8278 16.427 13.8278 17.5228C13.8278 18.6182 12.9363 19.5097 11.8404 19.5097Z" fill="#D21A12"/>' + '</svg>';
      $('#notifications.notifications-container li').each(function () {
        $(this).prepend(errorIcon);
      });
    }
  });

  if ($('body#authentication').length > 0 || $('body#checkout').length > 0) {
    $("input[name='id_gender']").on('change', function () {
      if ($(this).val() == '2') {
        // ID 2 == Company
        $('.additional-company-fields').css('display', 'block');
      } else {
        $('.additional-company-fields').css('display', 'none');
      }
    });
  }

  $(document).on('click', '.progress-list-item', function () {
    var targetSlideNum = $(this).attr('data-target');
    var allSlides = $('.checkout-step');
    var targetSlide = $('.checkout-step[data-slide=' + targetSlideNum + ']');

    if (targetSlideNum == 'krepselis') {
      $(document).find('.cart.contains-items')[0].click();
      return false;
    }

    if (!$(this).hasClass('-current')) {
      $('.progress-list-item').removeClass('-current');
      $(this).addClass('-current');
      allSlides.fadeOut(300);
      targetSlide.fadeIn(300);
    }
  });

  if ($('.delivery-options').length) {
    $(document).on('click', '.delivery-option-block', function (e) {
      if (!$(this).hasClass('active')) {
        var extraContent = $('.carrier-extra-content', $(this));
        $('.delivery-option-block').removeClass('active');
        $('.carrier-extra-content').hide();
        $('.delivery-option-block input').removeAttr('checked');
        $(this).find('input').prop('checked', true);
        $(this).addClass('active');
        extraContent.slideDown();
      }
    });
  } // First load.


  $('.checkout-step').off("click");
  $('.checkout-step').each(function (i) {
    var slideID = $(this).attr('data-slide');

    if (typeof slideID !== 'undefined') {
      $('.progress-list-item[data-target=' + slideID + ']').addClass($(this).attr("class")).removeClass('checkout-step js-current-step');
    } else {
      $('.progress-list-item[data-target=' + ($(this).index() + 1) + ']').addClass('-unreachable');
    }
  });
});

function accordion() {
  var toggle = $('.cart-summary-products .heading');
  var container = $('.cart-summary-products');
  var productscontainer = container.find('.collapse');
  toggle.on('click', function () {
    if (container.hasClass('opened')) {
      container.removeClass('opened');
      productscontainer.slideUp();
    } else {
      container.addClass('opened');
      productscontainer.slideDown();
    }
  });
}